/* tslint:disable */
/* eslint-disable */
/**
 * JET Charge Illuminate Web API
 * JET Charge Illuminate Web API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: rd@jetcharge.com.au
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface PinReleaseToDeviceRequest
 */
export interface PinReleaseToDeviceRequest {
    /**
     *
     * @type {number}
     * @memberof PinReleaseToDeviceRequest
     */
    releaseId?: number;
}

/**
 * Check if a given object implements the PinReleaseToDeviceRequest interface.
 */
export function instanceOfPinReleaseToDeviceRequest(
    value: object,
): value is PinReleaseToDeviceRequest {
    return true;
}

export function PinReleaseToDeviceRequestFromJSON(
    json: any,
): PinReleaseToDeviceRequest {
    return PinReleaseToDeviceRequestFromJSONTyped(json, false);
}

export function PinReleaseToDeviceRequestFromJSONTyped(
    json: any,
    ignoreDiscriminator: boolean,
): PinReleaseToDeviceRequest {
    if (json == null) {
        return json;
    }
    return {
        releaseId: json["releaseId"] == null ? undefined : json["releaseId"],
    };
}

export function PinReleaseToDeviceRequestToJSON(
    value?: PinReleaseToDeviceRequest | null,
): any {
    if (value == null) {
        return value;
    }
    return {
        releaseId: value["releaseId"],
    };
}
